export const TRANSLATION_PAIRS = [
  // Header / global
  ['Search Properties', 'Ürün Ara'],
  ['Dashboard', 'Panel'],
  ['Profile & Settings', 'Profil ve Ayarlar'],
  ['Saved Properties', 'Kayıtlı İlanlar'],
  ['Sign Out', 'Çıkış Yap'],
  ['Sign In', 'Giriş Yap'],
  ['Get Started', 'Başlayın'],
  ['Language', 'Dil'],
  ['Toggle mobile menu', 'Mobil menüyü aç/kapat'],
  ['Search agricultural products by type, location, or seller...', 'Tarımsal ürünleri tür, konum veya satıcıya göre ara...'],
  ['Search agricultural products...', 'Tarımsal ürün ara...'],
  ['Search for vegetables, fruits, grains, or farm products...', 'Sebze, meyve, tahıl veya çiftlik ürünlerinde arayın...'],
  ['Search options...', 'Arama seçenekleri...'],
  ['Search this area', 'Bu bölgede ara'],
  ['Search Products', 'Ürün Ara'],
  ['Search Product', 'Ürün Ara'],
  ['Searches', 'Aramalar'],

  // Common labels
  ['Home', 'Ana Sayfa'],
  ['Products', 'Ürünler'],
  ['Product', 'Ürün'],
  ['Product Details', 'Ürün Detayı'],
  ['Product Type', 'Ürün Türü'],
  ['Category', 'Kategori'],
  ['Price', 'Fiyat'],
  ['Price Range', 'Fiyat Aralığı'],
  ['Quantity', 'Miktar'],
  ['Location', 'Konum'],
  ['Status', 'Durum'],
  ['Actions', 'İşlemler'],
  ['Details', 'Detaylar'],
  ['View Details', 'Detayları Gör'],
  ['View All', 'Tümünü Gör'],
  ['View All Products', 'Tüm Ürünleri Gör'],
  ['View All Properties', 'Tüm İlanlari Gör'],
  ['View All Agents', 'Tüm Danışmanlari Gör'],
  ['Loading...', 'Yükleniyor...'],
  ['No data available', 'Veri bulunamadı'],
  ['No results', 'Sonuç bulunamadı'],
  ['No results found', 'Sonuç bulunamadı'],
  ['No activity', 'Etkinlik yok'],
  ['No Activity Found', 'Etkinlik bulunamadı'],
  ['No recent activity', 'Son etkinlik yok'],
  ['No leads', 'Lead yok'],
  ['No active listings found', 'Aktif ilan bulunamadı'],
  ['No showings scheduled', 'Planli gösterim yok'],
  ['No Payment Methods', 'Ödeme Yöntemi Yok'],
  ['No Active Subscriptions', 'Aktif Abonelik Yok'],
  ['No Favorite Properties', 'Favori İlan Yok'],
  ['No Properties Match Filter', 'Filtreye uyan ilan yok'],
  ['No Saved Searches', 'Kayıtlı Arama Yok'],
  ['No blocked users', 'Engelli kullanıcı yok'],
  ['No features listed for this product', 'Bu ürün için özellik listelenmemis'],
  ['No images available', 'Görsel bulunamadı'],
  ['Try adjusting your filter settings to see more properties.', 'Daha fazla ürün görmek için filtreleri değiştirin.'],

  // Buttons / actions
  ['Create Listing', 'İlan Oluştur'],
  ['Create New Listing', 'Yeni İlan Oluştur'],
  ['Add Listing', 'İlan Ekle'],
  ['Schedule Showing', 'Gösterim Planla'],
  ['Import Leads', 'Lead İçeri Aktar'],
  ['Generate Report', 'Rapor Oluştur'],
  ['Quick Actions', 'Hızlı İşlemler'],
  ['Quick Listing', 'Hızlı İlan'],
  ['Contact', 'İletişim'],
  ['Contact Seller', 'Satıcıya Ulaş'],
  ['Contact Farmer', 'Çiftçiye Ulaş'],
  ['Contact Agent', 'Danışmana Ulaş'],
  ['Call', 'Ara'],
  ['Call Now', 'Hemen Ara'],
  ['Message', 'Mesaj'],
  ['Send Message', 'Mesaj Gönder'],
  ['Send Bid', 'Teklif Gönder'],
  ['Sending Bid...', 'Teklif Gönderiliyor...'],
  ['Sending...', 'Gönderiliyor...'],
  ['Submit Offer', 'Teklif Gönder'],
  ['Submitting...', 'Gönderiliyor...'],
  ['Save', 'Kaydet'],
  ['Saved', 'Kaydedildi'],
  ['Save Changes', 'Değişiklikleri Kaydet'],
  ['Share', 'Paylas'],
  ['Share property', 'İlani paylas'],
  ['Export', 'Disa Aktar'],
  ['Export Data', 'Veriyi Disa Aktar'],
  ['Apply Filters', 'Filtreleri Uygula'],
  ['Filters', 'Filtreler'],
  ['Filter', 'Filtre'],
  ['Clear', 'Temizle'],
  ['Clear All', 'Tümünü Temizle'],
  ['Cancel', 'İptal'],
  ['Close', 'Kapat'],
  ['Close form', 'Formu kapat'],
  ['Remove', 'Kaldır'],
  ['Delete', 'Sil'],
  ['Delete Account', 'Hesabı Sil'],
  ['Delete My Account', 'Hesabımı Sil'],
  ['Unblock', 'Engeli Kaldır'],
  ['Back', 'Geri'],
  ['Back to Products', 'Ürünlere Dön'],
  ['Back to List', 'Listeye Dön'],
  ['Back to homepage', 'Ana sayfaya dön'],
  ['Go to Homepage', 'Ana Sayfaya Git'],
  ['Go Back', 'Geri Dön'],
  ['Upload Photo', 'Foto Yükle'],
  ['Uploading...', 'Yükleniyor...'],
  ['Upload leads from CSV or CRM', 'CSV veya CRM üzerinden lead yükleyin'],
  ['Click to upload photos', 'Fotoğraf yüklemek için tiklayin'],
  ['Add Card', 'Kart Ekle'],
  ['Add Your First Card', 'Ilk Kartinizi Ekleyin'],
  ['Set as Default', 'Varsayilan Yap'],
  ['Default', 'Varsayilan'],
  ['Manage All', 'Tümünü Yönet'],
  ['Schedule New', 'Yeni Planla'],
  ['Send reminder', 'Hatırlatma gönder'],
  ['Reschedule', 'Yeniden planla'],
  ['Pause alerts', 'Uyarıları duraklat'],
  ['Resume alerts', 'Uyarıları sürdür'],

  // Sort / list / map / status
  ['Sort:', 'Sirala:'],
  ['Best Match', 'En Uygun'],
  ['Price: Low to High', 'Fiyat: Düşükten Yuksege'],
  ['Price: High to Low', 'Fiyat: Yüksekten Düşüğe'],
  ['Newest First', 'En Yeniler'],
  ['Oldest First', 'En Eskiler'],
  ['Most Available', 'En Cok Stok'],
  ['List', 'Liste'],
  ['Map', 'Harita'],
  ['properties found', 'ürün bulundu'],
  ['products found', 'ürün bulundu'],
  ['properties', 'ürün'],
  ['products', 'ürün'],
  ['days ago', 'gun önce'],
  ['days', 'gun'],
  ['day ago', 'gun önce'],
  ['Just now', 'Simdi'],
  ['minutes ago', 'dakika önce'],
  ['hours ago', 'saat önce'],
  ['Yesterday', 'Dun'],
  ['Active', 'Aktif'],
  ['Pending', 'Beklemede'],
  ['Under Contract', 'Sozlesmede'],
  ['Sold', 'Satildi'],
  ['Paused', 'Duraklatildi'],
  ['Daily', 'Günlük'],
  ['Weekly', 'Haftalik'],
  ['Immediate', 'Anlik'],
  ['All Activity', 'Tüm Etkinlik'],
  ['Property Views', 'İlan Görüntülemeleri'],
  ['Search History', 'Arama Geçmişi'],
  ['Messages', 'Mesajlar'],
  ['Logins', 'Girişler'],
  ['Favorites', 'Favoriler'],

  // Home page
  ['Fresh Farm Products Direct to You', 'Taze Çiftlik Ürünleri Doğrudan Size'],
  ['Discover fresh, high-quality agricultural products from local farmers.', 'Yerel üreticilerden taze ve yuksek kaliteli tarım ürünlerini keşfedin.'],
  ['Organic Vegetables', 'Organik Sebzeler'],
  ['Fresh Fruits', 'Taze Meyveler'],
  ['Premium Grains', 'Premium Tahillar'],
  ['Dairy Products', 'Sut Ürünleri'],
  ['Free-range Eggs', 'Gezen Tavuk Yumurtasi'],
  ['Featured Agricultural Products', 'One Cikan Tarım Ürünleri'],
  ['Product Locations', 'Ürün Konumlari'],
  ['Trusted by Thousands', 'Binlerce Kışi Tarafindan Guveniliyor'],
  ['Active Properties', 'Aktif İlanlar'],
  ['Cities Covered', 'Kapsanan Şehirler'],
  ['Successful Sales', 'Başarılı Satışlar'],
  ['Expert Agents', 'Uzman Danışmanlar'],
  ['Verified Listings', 'Doğrulanmis İlanlar'],
  ['All properties verified', 'Tüm ilanlar doğrulandi'],
  ['24/7 Support', '7/24 Destek'],
  ['Always here to help', 'Her zaman yardima hazir'],
  ['Award Winning', 'Odullu Hizmet'],
  ['Industry recognized', 'Sektor tarafindan taninan'],
  ['Meet Our Top Agents', 'En Iyi Danışmanlarimiz'],
  ['Specialties:', 'Uzmanliklar:'],
  ['Achievements:', 'Başarılar:'],
  ['Previous agent', 'Onceki danışman'],
  ['Next agent', 'Sonraki danışman'],
  ['Go to agent', 'Danışmana git'],

  // Footer
  ['For Buyers', 'Alıcılar İçin'],
  ['For Sellers', 'Satıcılar İçin'],
  ['For Agents', 'Danışmanlar İçin'],
  ['Company', 'Sirket'],
  ['About Us', 'Hakkimizda'],
  ['Careers', 'Kariyer'],
  ['Press', 'Basin'],
  ['Stay Updated', 'Güncel Kalin'],
  ['Get the latest property listings and market insights delivered to your inbox.', 'En güncel ilanlari ve pazar bilgilerimizi e-postanizda alin.'],
  ['Enter your email', 'E-posta adresinizi girin'],
  ['Subscribe', 'Abone Ol'],
  ['All rights reserved.', 'Tüm haklari saklidir.'],
  ['Privacy Policy', 'Gizlilik Politikasi'],
  ['Terms of Service', 'Hizmet Kosullari'],
  ['Cookie Policy', 'Cerez Politikasi'],
  ['Accessibility', 'Erisilebilirlik'],

  // Listing filters
  ['Farm Products for Sale', 'Satilik Tarım Ürünleri'],
  ['Search farm products...', 'Tarım ürünü ara...'],
  ['Farm Location', 'Çiftlik Konumu'],
  ['Enter state or location...', 'Bölge veya konum girin...'],
  ['All Products', 'Tüm Ürünler'],
  ['Vegetables', 'Sebzeler'],
  ['Fruits', 'Meyveler'],
  ['Grains', 'Tahillar'],
  ['Dairy', 'Sut Ürünleri'],
  ['Meat & Poultry', 'Et ve Kumes'],
  ['Herbs & Spices', 'Otlar ve Baharatlar'],
  ['Min ($)', 'Min ($)'],
  ['Max ($)', 'Maks ($)'],
  ['Organic Certified', 'Organik Sertifikali'],
  ['Any', 'Farketmez'],
  ['Organic Only', 'Sadece Organik'],
  ['Conventional', 'Geleneksel'],
  ['Quantity Available', 'Mevcut Miktar'],
  ['Any Amount', 'Herhangi Bir Miktar'],
  ['Harvest Season', 'Hasat Donemi'],
  ['Any Season', 'Tüm Mevsimler'],
  ['Spring', 'İlkbahar'],
  ['Summer', 'Yaz'],
  ['Fall', 'Sonbahar'],
  ['Winter', 'Kış'],
  ['Special Features', 'Özel Özellikler'],
  ['Pesticide Free', 'Pestisit Yok'],
  ['Locally Grown', 'Yerel Uretim'],
  ['Fresh Harvest', 'Taze Hasat'],
  ['Family Farm', 'Aile Ciftligi'],
  ['Sustainable Practices', 'Sürdürulebilir Uygulamalar'],
  ['Active filters:', 'Aktif filtre:'],
  ['Organic', 'Organik'],
  ['Add to favorites', 'Favorilere ekle'],
  ['Remove from favorites', 'Favorilerden kaldır'],
  ['Highest Bid:', 'En Yüksek Teklif:'],
  ['New Listing', 'Yeni İlan'],
  ['New', 'Yeni'],
  ['Bid', 'Teklif'],
  ['Available:', 'Mevcut:'],
  ['Listed:', 'Yayinlanma:'],
  ['Seller Rating:', 'Satıcı Puani:'],
  ['Current Bids', 'Güncel Teklifler'],
  ['Send Your Bid', 'Teklifinizi Gönderin'],
  ['Bid Amount (per', 'Teklif Tutari ('],
  ['Suggested:', 'Onerilen:'],
  ['Your bid should be higher than', 'Teklifiniz su degerden yuksek olmali:'],
  ['Message to Seller (Optional)', 'Satıcıya Mesaj (Opsiyonel)'],
  ['Add any special requests or questions...', 'Özel taleplerinizi veya sorularinizi yazin...'],
  ['Total Bid:', 'Toplam Teklif:'],
  ['Select a Product', 'Bir Ürün Seçin'],
  ['Click on a product from the list to send bids and view details', 'Teklif göndermek ve detay görmek için listeden ürün seçin'],
  ['Loading map...', 'Harita yükleniyor...'],

  // Property details
  ['Product Not Found', 'Ürün Bulunamadi'],
  ["The agricultural product you're looking for doesn't exist or has been removed.", 'Aradiginiz tarım ürünü bulunamadı veya kaldırildi.'],
  ['Place Order', 'Siparis Ver'],
  ['Farm Owner & Producer', 'Çiftlik Sahibi ve Üretici'],
  ['Certified Organic Producer', 'Sertifikali Organik Üretici'],
  ['Harvested Today', 'Bugun hasat edildi'],
  ['Harvested Yesterday', 'Dun hasat edildi'],
  ['Harvest Date', 'Hasat Tarihi'],
  ['Storage Temp', 'Depolama Sıcakligi'],
  ['Days Fresh', 'Tazelik (Gun)'],
  ['Days Listed', 'Yayinda Kalma (Gun)'],
  ['Variety:', 'Cesit:'],
  ['Freshness:', 'Tazelik:'],
  ['Description', 'Açıklama'],
  ['Offers', 'Teklifler'],
  ['Field Activities', 'Tarla Faaliyetleri'],
  ['Features', 'Özellikler'],
  ['Harvest Informatıon', 'Hasat Bilgisi'],
  ['Harvested on:', 'Hasat Tarihi:'],
  ['Highest', 'En Yüksek'],
  ['No bids yet for this product', 'Bu ürün için henüz teklif yok'],
  ['Agrochain Integration', 'Agrochain Entegrasyonu'],
  ['Field activities are tracked and verified through our Agrochain platform, ensuring transparency and quality assurance.', 'Tarla faaliyetleri Agrochain platformunda takip edilir ve doğrulanır.'],
  ['Materials Used:', 'Kullanilan Malzemeler:'],
  ['Verified', 'Doğrulandi'],
  ['Quality Assurance', 'Kalite Guvencesi'],
  ['Organic Certification', 'Organik Sertifikasyon'],
  ['Delivery Available', 'Teslimat Mevcut'],
  ['Local delivery within 25 miles', '25 mil içinde yerel teslimat'],
  ['Farm Hours', 'Çiftlik Saatleri'],
  ['Contact', 'İletişim'],
  ['Interactive farm location map would be embedded here', 'Etkilesimli çiftlik haritasi burada gösterilir'],
  ['Coordinates:', 'Koordinatlar:'],
  ['Nearby Agricultural Services', 'Yakin Tarımsal Hizmetler'],
  ['Similar Agricultural Products', 'Benzer Tarım Ürünleri'],
  ['Make an Offer', 'Teklif Ver'],
  ['Offer Price (per', 'Teklif Fiyati ('],
  ['Message (optional)', 'Mesaj (opsiyonel)'],
  ['Add any special requirements or questions...', 'Özel taleplerinizi veya sorularinizi ekleyin...'],
  ['Total Offer:', 'Toplam Teklif:'],
  ['Submit Offer', 'Teklif Gönder'],
  ['Recent Offers', 'Son Teklifler'],
  ['Mortgage Calculator', 'Kredi Hesaplayıcı'],
  ['Property Price', 'Ürün Fiyati'],
  ['Down Payment', 'Pesinat'],
  ['Loan Amount', 'Kredi Tutari'],
  ['Interest Rate', 'Faiz Orani'],
  ['Loan Term', 'Vade'],
  ['Custom term (years)', 'Özel vade (yil)'],
  ['Additional Monthly Costs', 'Aylik Ek Masraflar'],
  ['Property Tax (monthly)', 'Emlak Vergisi (aylik)'],
  ['Home Insurance (monthly)', 'Konut Sigortasi (aylik)'],
  ['PMI (monthly)', 'PMI (aylik)'],
  ['HOA Fees (monthly)', 'Site Aidati (aylik)'],
  ['Monthly Payment Breakdown', 'Aylik Ödeme Dagilimi'],
  ['Principal & Interest:', 'Anapara ve Faiz:'],
  ['Property Tax:', 'Emlak Vergisi:'],
  ['Home Insurance:', 'Konut Sigortasi:'],
  ['PMI:', 'PMI:'],
  ['HOA Fees:', 'Site Aidati:'],
  ['Total Monthly Payment:', 'Toplam Aylik Ödeme:'],
  ['This calculator provides estimates only. Actual payments may vary based on lender terms, fees, and other factors.', 'Bu hesaplayıcı tahmini sonuç verir. Gerçek ödeme degisebilir.'],
  ['Virtual Tour', 'Sanal Tur'],
  ['Video', 'Video'],
  ['Fullscreen', 'Tam Ekran'],
  ['View fullscreen', 'Tam ekran görüntüle'],
  ['Close fullscreen', 'Tam ekrani kapat'],
  ['Previous image', 'Onceki gorsel'],
  ['Next image', 'Sonraki gorsel'],

  // Login / not found
  ['Page Not Found', 'Sayfa Bulunamadi'],
  ["The page you're looking for doesn't exist or has been moved.", 'Aradiginiz sayfa bulunamadı veya tasindi.'],
  ['Unexpected error occurred.', 'Beklenmeyen bir hata olustu.'],
  ['Signing in...', 'Giriş yapiliyor...'],
  ['Demo accounts:', 'Demo hesaplar:'],
  ['Sign in with your AgroMart account', 'AgroMart hesabinla giriş yap'],
  ['Sign in with your AgroMart account', 'AgroMart hesab1nla giri_ yap'],
  ['No registration flow yet. Use demo users for now.', 'Henüz kayıt akisi yok. Şimdilik demo kullanıcılarla giriş yap.'],
  ['No registration flow yet. Use demo users for now.', 'Hen�z kay1t ak1_1 yok. ^imdilik demo kullan1c1larla giri_ yap.'],

  // Agent dashboard
  ['Agent Dashboard', 'Danışman Paneli'],
  ['Manage your listings, track leads, and monitor performance', 'İlanlarinizi yönetin, leadleri takip edin ve performansi izleyin'],
  ['Active Listings', 'Aktif İlanlar'],
  ['New Leads', 'Yeni Leadler'],
  ['This Month Closings', 'Bu Ay Kapanislar'],
  ['Total Revenue', 'Toplam Gelir'],
  ['Lead Pipeline', 'Lead Hatti'],
  ['Recent Activity', 'Son Etkinlikler'],
  ['Upcoming Showings', 'Yaklasan Gösterimler'],
  ['Performance Analytics', 'Performans Analitigi'],
  ['Listings', 'İlanlar'],
  ['Leads', 'Leadler'],
  ['Sales', 'Satışlar'],
  ['Revenue', 'Gelir'],
  ['Monthly Revenue', 'Aylik Gelir'],
  ['Last 7 days', 'Son 7 gun'],
  ['Last 30 days', 'Son 30 gun'],
  ['Last 3 months', 'Son 3 ay'],
  ['Last year', 'Son 1 yil'],
  ['Export as PDF', 'PDF olarak dışa aktar'],
  ['Export as Excel', 'Excel olarak dışa aktar'],
  ['Export as CSV', 'CSV olarak dışa aktar'],
  ['No leads', 'Lead yok'],
  ['No recent activity', 'Son etkinlik yok'],
  ['No active listings found', 'Aktif ilan bulunamadı'],

  // Profile settings
  ['Profile Informatıon', 'Profil Bilgileri'],
  ['Update your personal informatıon and profile photo', 'Kişisel bilgilerinizi ve profil fotografinizi güncelleyin'],
  ['Only image files are allowed.', 'Sadece gorsel dosyalari kabul edilir.'],
  ['Image size must be 5MB or less.', 'Görsel boyutu en fazla 5MB olmali.'],
  ['Profile photo updated.', 'Profil fotografi güncellendi.'],
  ['Profile photo removed.', 'Profil fotografi kaldırildi.'],
  ['Failed to upload profile photo.', 'Profil fotografi yüklenemedi.'],
  ['Failed to remove profile photo.', 'Profil fotografi kaldırilamadi.'],
  ['Profile informatıon saved successfully.', 'Profil bilgileri başarıyla kaydedildi.'],
  ['Failed to save profile informatıon.', 'Profil bilgileri kaydedilemedi.'],
  ['Email Address', 'E-posta Adresi'],
  ['Phone Number', 'Telefon Numarasi'],
  ['Website', 'Web Sitesi'],
  ['Bio', 'Hakkinda'],
  ['characters', 'karakter'],
  ['Password & Security', 'Şifre ve Guvenlik'],
  ['Change Password', 'Şifre Değiştir'],
  ['Current Password', 'Mevcut Şifre'],
  ['New Password', 'Yeni Şifre'],
  ['Confirm New Password', 'Yeni Şifreyi Onayla'],
  ['Update Password', 'Şifreyi Güncelle'],
  ['Email Preferences', 'E-posta Tercihleri'],
  ['Notification Settings', 'Bildirim Ayarları'],
  ['Data & Privacy', 'Veri ve Gizlilik'],
  ['Contact Preferences', 'İletişim Tercihleri'],
  ['Blocked Users', 'Engellenen Kullanıcılar'],
  ['Block User', 'Kullanıcıyi Engelle'],
  ['Danger Zone', 'Tehlikeli Bölge'],
  ['Account Login', 'Hesap Girişi'],
  ['Profile Updated', 'Profil Güncellendi'],
  ['Saved Searches', 'Kayıtlı Aramalar'],
  ['Favorite Properties', 'Favori İlanlar'],
  ['Activity History', 'Etkinlik Geçmişi'],
  ['Business Profile', 'İşletme Profili'],
  ['Payment Methods', 'Ödeme Yöntemleri'],
  ['Unsaved changes', 'Kaydedilmemiş değişiklikler'],
  ['Saving...', 'Kaydediliyor...'],
  ['Saved', 'Kaydedildi'],
  ['Save failed', 'Kayıt başarısız'],
  ['Map Selection', 'Harita Secimi'],
  ['Add', 'Ekle'],
  ['Quick Add:', 'Hızlı Ekle:'],
  ['Export', 'Disa Aktar'],
  ['Create New Search', 'Yeni Arama Oluştur'],
  ['Edit Saved Search', 'Kayıtlı Aramayı Düzenle'],
  ['Notification Frequency', 'Bildirim Sikligi'],
  ['Created', 'Oluşturma'],
  ['Last updated', 'Son güncelleme'],
  ['Added', 'Eklenme'],
  ['Agent:', 'Danışman:'],

  // Second-pass coverage
  ['Active Listings (', 'Aktif İlanlar ('],
  ['Active Only', 'Sadece Aktif'],
  ['Active Subscriptions', 'Aktif Abonelikler'],
  ['activity records', 'etkinlik kaydi'],
  ['Activity Summary', 'Etkinlik Ozeti'],
  ['Activity type:', 'Etkinlik tipi:'],
  ['Add a payment method to manage subscriptions and premium features.', 'Abonelikleri ve premium özellikleri yönetmek için bir ödeme yöntemi ekleyin.'],
  ['Add Payment Method', 'Ödeme Yöntemi Ekle'],
  ['Afternoon (12 PM - 5 PM)', 'Ogleden sonra (12:00 - 17:00)'],
  ['Agricultural Marketplace Notifications', 'Tarım Pazari Bildirimleri'],
  ['All field activities are documented and verified through blockchain technology on our Agrochain platform, ensuring complete traceability and quality assurance for this product.', 'Tüm tarla faaliyetleri Agrochain platformunda blockchain ile kaydedilir ve doğrulanır; bu üründe tam izlenebilirlik ve kalite guvencesi saglanir.'],
  ['All Properties', 'Tüm İlanlar'],
  ['Any Price', 'Herhangi Bir Fiyat'],
  ['Are you absolutely sure you want to delete your account? This will:', 'Hesabınizi silmek istediginizden tamamen emin misiniz? Bu işlem:'],
  ['Bathrooms *', 'Banyo *'],
  ['Baths:', 'Banyo:'],
  ['Bedrooms *', 'Yatak Odasi *'],
  ['Beds:', 'Yatak Odasi:'],
  ['Best Time to Contact', 'İletişim İçin En Uygun Saat'],
  ['Billing Address', 'Fatura Adresi'],
  ['Billing History', 'Fatura Geçmişi'],
  ["Blocked users won't be able to contact you or see your profile.", 'Engellenen kullanıcılar sizinle iletişime gecemez ve profilinizi göremez.'],
  ['Bulk Actions', 'Toplu İşlemler'],
  ["Buyer's Guide", 'Alıcı Rehberi'],
  ["Seller's Guide", 'Satıcı Rehberi'],
  ['Cancel any active subscriptions or listings', 'Aktif abonelikleri veya ilanlari iptal et'],
  ['Card Number', 'Kart Numarasi'],
  ['Cardholder Name', 'Kart Uzerindeki Isim'],
  ['Choose what emails you\'d like to receive about agricultural products and marketplace updates', 'Tarım ürünleri ve pazar güncellemeleriyle ilgili hangi e-postalari almak istediginizi seçin'],
  ['City *', 'Şehir *'],
  ['Control how you receive notifications about orders and agricultural marketplace activity', 'Siparisler ve tarım pazari etkinlikleri hakkında bildirimleri nasıl alacağınızı yönetin'],
  ['Control how your agricultural marketplace data is used and shared', 'Tarım pazari verilerinizin nasıl kullanilacagini ve paylasilacagini yönetin'],
  ['Control who can see your profile informatıon', 'Profil bilgilerinizi kimin görecegini yönetin'],
  ['Create your first saved search to get notified about new properties that match your criteria.', 'Kriterlerinize uyan yeni ilanlar için ilk kayıtlı aramanızı oluşturun.'],
  ['Create Your First Search', 'Ilk Aramanizi Olustürün'],
  ['Created:', 'Olustürülma:'],
  ['CSV Format', 'CSV Formati'],
  ['Date Added', 'Eklenme Tarihi'],
  ['Date range:', 'Tarih aralığı:'],
  ['Days on Market', 'Yayinda Kalma Suresi'],
  ['Delete all transaction and message history', 'Tüm işlem ve mesaj geçmişini sil'],
  ['Delete saved search?', 'Kayıtlı arama silinsin mi?'],
  ['Delete search', 'Aramayı sil'],
  ['Describe the property features, amenities, and highlights...', 'İlanın özelliklerini, imkanlarını ve öne çıkan noktalarini açıklayın...'],
  ['Discuss Price', 'Fiyati Goruselim'],
  ['Down Payment (', 'Pesinat ('],
  ['Edit search', 'Aramayı düzenle'],
  ['Email Address *', 'E-posta Adresi *'],
  ['Enter your full name', 'Ad soyad girin'],
  ['EstateHub. All rights reserved.', 'EstateHub. Tüm haklari saklidir.'],
  ['Evening (5 PM - 8 PM)', 'Aksam (17:00 - 20:00)'],
  ['Expiry Month', 'Son Kullanma Ayi'],
  ['Expiry Year', 'Son Kullanma Yili'],
  ['Export Activity Data', 'Etkinlik Verisini Disa Aktar'],
  ['Export includes:', 'Disa aktarım icerigi:'],
  ['Features:', 'Özellikler:'],
  ['Full Name *', 'Ad Soyad *'],
  ['Irreversible actions that affect your agricultural marketplace account', 'Tarım pazari hesabinizi etkileyen geri alinamaz islemler'],
  ['JSON Format', 'JSON Formati'],
  ['Last updated:', 'Son güncelleme:'],
  ['List Your Property', 'İlan Ver'],
  ['Load More Activity', 'Daha Fazla Etkinlik Yükle'],
  ['Location:', 'Konum:'],
  ['Machine-readable format with all metadata', 'Tüm metadata ile makine okunabilir format'],
  ['Manage how other farmers and buyers can contact you', 'Diğer ciftci ve alıcılarin sizinle nasıl iletişime gececegini yönetin'],
  ['Manage users who cannot contact you about agricultural products', 'Tarım ürünleri için sizinle iletişime gecemeyecek kullanıcılari yönetin'],
  ['Manage your account and preferences', 'Hesabınizi ve tercihlerinizi yönetin'],
  ['Manage your listed properties', 'Yayindaki ilanlarinizi yönetin'],
  ['Manage your password and security settings', 'Şifre ve guvenlik ayarlarınizi yönetin'],
  ['Manage your premium subscriptions', 'Premium aboneliklerinizi yönetin'],
  ['Manage your property listings', 'İlanlarinizi yönetin'],
  ['Manage your property search alerts and notification frequency', 'İlan arama uyarılarinizi ve bildirim sikligini yönetin'],
  ['Manage your saved payment methods', 'Kayıtlı ödeme yöntemlerinizi yönetin'],
  ['Marketing Campaign', 'Pazarlama Kampanyasi'],
  ['Message *', 'Mesaj *'],
  ['Message Sent Successfully!', 'Mesaj Başarıyla Gönderildi!'],
  ['More Filters', 'Daha Fazla Filtre'],
  ['Morning (8 AM - 12 PM)', 'Sabah (08:00 - 12:00)'],
  ['Neighborhood Info', 'Bölge Bilgisi'],
  ['Next Billing:', 'Sonraki Ödeme:'],
  ['No activity found for the selected period and type.', 'Seçilen dönem ve tip için etkinlik bulunamadı.'],
  ['No products found', 'Ürün bulunamadı'],
  ['Over $500', '$500 Ustu'],
  ['Payment Method', 'Ödeme Yöntemi'],
  ['Permanently delete all your profile and farm informatıon', 'Tüm profil ve çiftlik bilgilerinizi kalıcı olarak sil'],
  ['Permanently delete your agricultural marketplace account and all associated data. This action cannot be undone.', 'Tarım pazari hesabinizi ve bagli tüm verileri kalıcı olarak silin. Bu işlem geri alinamaz.'],
  ['Phone Call', 'Telefon Aramasi'],
  ['Phone Number *', 'Telefon Numarasi *'],
  ['PNG, JPG up to 10MB each', 'PNG, JPG her biri en fazla 10MB'],
  ['Preferred Contact Method', 'Tercih Edilen İletişim Yöntemi'],
  ['Price *', 'Fiyat *'],
  ['Price Change', 'Fiyat Degisimi'],
  ['Price Drop', 'Fiyat Dustu'],
  ['Price Drops', 'Fiyat Dususleri'],
  ['Price:', 'Fiyat:'],
  ['Product ID:', 'Ürün ID:'],
  ['Profile Visibility', 'Profil Gorunurlugu'],
  ['Property Address', 'İlan Adresi'],
  ['Property Details', 'İlan Detayları'],
  ['Property Map', 'İlan Haritasi'],
  ['Property Type *', 'İlan Türü *'],
  ['Public Profile URL', 'Herkese Acik Profil URL'],
  ['Quantity (', 'Miktar ('],
  ['Remove all saved searches and favorite agricultural products', 'Tüm kayıtlı aramalari ve favori tarım ürünlerini kaldır'],
  ['Request More Info', 'Daha Fazla Bilgi Iste'],
  ['Required for down payments less than 20%', 'Pesinat %20\'den dusukse gereklidir'],
  ['Saved search deleted', 'Kayıtlı arama silindi'],
  ['Search Name', 'Arama Adı'],
  ['Select All', 'Tümünü Sec'],
  ['Select type', 'Tur seçin'],
  ['Select...', 'Seçiniz...'],
  ['Select an option', 'Seçiniz'],
  ['selected properties via:', 'secilen ilanlar su kanalla:'],
  ['Share Properties', 'İlanlari Paylas'],
  ['Something went wrong', 'Bir seyler ters gitti'],
  ['Spreadsheet-compatible format', 'Tabloya uygun format'],
  ['State *', 'Eyalet/Il *'],
  ['Status:', 'Durum:'],
  ['Street Address', 'Sokak Adresi'],
  ['Street Address *', 'Sokak Adresi *'],
  ['Sync with MLS', 'MLS ile Esitle'],
  ['Tell us about your interest in this property...', 'Bu ilana ilginizi kisaca yazin...'],
  ['Text Message', 'SMS'],
  ['Thank you for your interest.', 'İlginiz için teşekkür ederiz.'],
  ['This action cannot be undone!', 'Bu işlem geri alinamaz!'],
  ['This product is certified organic and grown without synthetic pesticides, herbicides, or fertilizers.', 'Bu ürün organik sertifikalıdir; sentetik pestisit, herbisit veya gübre kullanilmadan yetistirilmistir.'],
  ['Track your recent activity and account actions', 'Son etkinliklerinizi ve hesap islemlerinizi takip edin'],
  ['Try adjusting your search criteria or filters', 'Arama kriterlerini veya filtreleri değiştirmeyi deneyin'],
  ['Type:', 'Tur:'],
  ['Under $25', '$25 Alti'],
  ['Update Status', 'Durumu Güncelle'],
  ['Upgrade to a premium plan to access advanced features.', 'Gelismis özelliklere erismek için premium plana gecin.'],
  ['View your payment history and download invoices', 'Ödeme geçmişinizi gorun ve faturalarinizi indirin'],
  ['We encountered an unexpected error while processing your request.', 'Isteginiz islenirken beklenmeyen bir hata olustu.'],
  ['will contact you within 24 hours.', '24 saat içinde sizinle iletişime gececek.'],
  ['Yes, Delete My Account', 'Evet, Hesabımı Sil'],
  ['You can set specific frequency settings for each type of agricultural marketplace notification in the advanced settings.', 'Her bildirim tipi için gelişmiş ayarlardan özel sıklık ayarları yapabilirsiniz.'],
  ['Your informatıon will only be shared with the listing agent and will not be used for marketing purposes.', 'Bilgileriniz yalnizca ilan yetkilisiyle paylasilir ve pazarlama amacli kullanilmaz.'],
  ['Your profile is accessible at:', 'Profilinize su adresten ulasilabilir:'],
  ['Your trusted partner in real estate. We connect buyers, sellers, and agents to create successful property transactions across the country.', 'Gayrimenkulde güvenilir is ortağınız. Alıcı, satıcı ve danışmanları buluşturarak ülke genelinde başarılı işlem saglariz.'],
  ['ZIP Code', 'Posta Kodu'],
  ['Listing Analytics', 'İlan Analitigi'],
  ['My Listings', 'İlanlarim'],
  ['My Properties', 'İlanlarim'],
  ['Client Management', 'Musteri Yönetimi'],
  ['Help & Support', 'Yardim ve Destek'],
  ['Sign out of your account', 'Hesabınizdan çıkış yapin'],
  ['Recent searches and alerts', 'Son aramalar ve uyarılar'],
  ['View your favorite listings', 'Favori ilanlarinizi gorun'],
  ['View and manage clients', 'Müşterileri görüntüleyin ve yönetin'],
  ['View property performance', 'İlan performansını görüntüleyin'],
  ['User account menu', 'Kullanıcı hesap menusu'],
  ['1-10 lbs', '1-10 lb'],
  ['10-50 lbs', '10-50 lb'],
  ['50-200 lbs', '50-200 lb'],
  ['200+ lbs', '200+ lb'],
  ['1-100 kg', '1-100 kg'],
  ['100-500 kg', '100-500 kg'],
  ['500 kg - 1 ton', '500 kg - 1 ton'],
  ['Above 1 ton', '1 ton ustu'],
  ['Error fetching product details:', 'Ürün detayları alinirken hata:'],
  ['Error fetching products:', 'Ürünler alinirken hata:'],
  ['Error submitting bid:', 'Teklif gönderilirken hata:'],
  ['Error submitting form:', 'Form gönderilirken hata:'],
  ['Error submitting listing:', 'İlan gönderilirken hata:'],
  ['Error submitting offer:', 'Teklif gönderilirken hata:'],
  ['Failed to fetch profile:', 'Profil alinirken hata:'],
  ['Failed to remove avatar:', 'Avatar silinirken hata:'],
  ['Failed to update profile:', 'Profil güncellenirken hata:'],
  ['Failed to upload avatar:', 'Avatar yüklenirken hata:'],
  ['Agent Resources', 'Danışman Kaynaklari'],
  ['Home Valuation', 'Ev Degerleme'],
  ['Market Reports', 'Pazar Raporlari'],
  ['Join Our Team', 'Ekibimize Katilin'],
  ['Training Center', 'Egitim Merkezi'],
  ['Manage your account informatıon and preferences', 'Hesap bilgilerinizi ve tercihlerinizi yönetin'],
  ['Discover fresh, high-quality agricultural products from certified farms across the country', 'Ülke genelindeki sertifikalı çiftliklerden taze ve kaliteli tarım ürünlerini keşfedin'],
  ['Discover our handpicked selection of premium properties from top locations across the country', 'Ülke genelindeki seçkin lokasyonlardan özenle seçilmiş premium ilanlari keşfedin'],
  ['Join our growing community of satisfied buyers, sellers, and agents who have found success through our platform', 'Platformumuzla başarıya ulasan alıcı, satıcı ve danışmanlardan olusan buyuyen toplulugumuza katilin'],
  ['Work with industry-leading professionals who are committed to helping you achieve your real estate goals', 'Gayrimenkul hedeflerinize ulaşmanız için yanınızda olan sektör lideri profesyonellerle çalışın'],
  ['Additional informatıon about your farming operation', 'Tarımsal işletmeniz hakkında ek bilgiler'],
  ['Agricultural Business Details', 'Tarımsal İşletme Detayları'],
  ['Agricultural Certifications', 'Tarımsal Sertifikalar'],
  ['Agricultural marketplace communications', 'Tarım pazari iletişimleri'],
  ['Agricultural Specializations', 'Tarımsal Uzmanliklar'],
  ['All Areas', 'Tüm Bölgeler'],
  ['All time', 'Tüm zamanlar'],
  ['Allow direct contact through platform', 'Platform üzerinden dogrudan iletişime izin ver'],
  ['Allow sharing of anonymized data with agricultural industry partners', 'Anonimlestirilmis verilerin tarım sektöru partnerleriyle paylasilmasina izin ver'],
  ['Allow your profile to be found in seller/farmer searches', 'Profilinizin satıcı/ciftci aramalarinda bulunmasina izin ver'],
  ['Appear in search results', 'Arama sonuçlarinda gorunsun'],
  ['Define the regions where you distribute your products', 'Ürünlerinizi dagittiginiz bölgeleri belirleyin'],
  ['Details about your agricultural operation', 'Tarımsal operasyonunuzla ilgili detaylar'],
  ['Display when you are currently active on the marketplace', 'Pazaryerinde aktif oldugunuzda göster'],
  ['Display your email and phone number to potential buyers', 'E-posta ve telefon bilginizi potansiyel alıcılara göster'],
  ['Distribution Areas', 'Dagitim Bölgeleri'],
  ['Enter state or availability location...', 'Il veya uygunluk konumu girin...'],
  ['Export your activity history for personal records. Choose your preferred format:', 'Kişisel kayıtlarınız için etkinlik geçmişinizi dışa aktarın. Tercih ettiğiniz formatı seçin:'],
  ['Farm Address', 'Çiftlik Adresi'],
  ['Farm Certification & Licensing', 'Çiftlik Sertifika ve Lisans'],
  ['Farm Informatıon', 'Çiftlik Bilgileri'],
  ['Farm License/Permit Number *', 'Çiftlik Lisans/Izin Numarasi *'],
  ['Farm Phone', 'Çiftlik Telefonu'],
  ['Farm Size (acres)', 'Çiftlik Buyuklugu (acre)'],
  ['Farm Type', 'Çiftlik Türü'],
  ['Farm Website', 'Çiftlik Web Sitesi'],
  ['Farm/Business Name *', 'Çiftlik/İşletme Adı *'],
  ['Featured Properties', 'One Cikan İlanlar'],
  ['Full-time Operations', 'Tam Zamanli Operasyon'],
  ['Harvest Season Only', 'Sadece Hasat Donemi'],
  ['Highlight your farming expertise and product specialities', 'Çiftçilik uzmanliginizi ve ürün uzmanliklarinizi one cikar1n'],
  ['Integration with mapping services like Google Maps or Mapbox', 'Google Maps veya Mapbox gibi harita servisleriyle entegrasyon'],
  ['Interactive map for service area selection would be implemented here', 'Hizmet alani secimi için etkilesimli harita burada olacak'],
  ['JPG/PNG, max 5MB', 'JPG/PNG, en fazla 5MB'],
  ['Languages Spoken', 'Konusulan Diller'],
  ['Last changed 3 months ago', 'Son değişiklik 3 ay önce'],
  ['Modify Plan', 'Plani Değiştir'],
  ['Mon-Sat: 7:00 AM - 6:00 PM', 'Pzt-Cmt: 07:00 - 18:00'],
  ['New passwords do not match', 'Yeni şifreler eslesmiyor'],
  ['Only visible to verified agricultural sellers', 'Sadece doğrulanmış tarım satıcılarina görünür'],
  ['Only you can see your profile informatıon', 'Profil bilgilerinizi sadece siz görebilirsiniz'],
  ['Operating State/Region *', 'Faaliyet Gösterdiginiz Il/Bölge *'],
  ['Operation Schedule', 'Operasyon Takvimi'],
  ['Organic Farming', 'Organik Tarım'],
  ['Other users can send you messages about agricultural products', 'Diğer kullanıcılar size tarım ürünleri hakkında mesaj gönderebilir'],
  ['Please select an image.', 'Lutfen bir gorsel seçin.'],
  ['Profile Updates', 'Profil Güncellemeleri'],
  ['Receive personalized product recommendations', 'Kişisellestirilmis ürün önerileri alin'],
  ['Receive promotional emails and marketplace updates', 'Tanitim e-postalari ve pazar güncellemeleri alin'],
  ['Sellers Only', 'Sadece Satıcılar'],
  ['Share data with trusted agricultural partners', 'Verileri güvenilir tarım partnerleriyle paylas'],
  ['Show contact informatıon on profile', 'İletişim bilgilerini profilde göster'],
  ['Show online status', 'Cevrimici durumunu göster'],
  ['Signed in from Chrome on MacOS', 'MacOS uzerinde Chrome ile giriş yapildi'],
  ['Subscription cancelled', 'Abonelik iptal edildi'],
  ['Tell us about yourself...', 'Kendinizden bahsedin...'],
  ['This card will be removed from your account.', 'Bu kart hesabinizdan kaldırilacak.'],
  ['This property will be removed from your favorites list.', 'Bu ilan favorilerinizden kaldırilacak.'],
  ['This saved search and its alert settings will be removed.', 'Bu kayıtlı arama ve uyarı ayarları kaldırilacak.'],
  ['Updated contact informatıon', 'İletişim bilgileri güncellendi'],
  ['Use your activity to suggest relevant agricultural products', 'Etkinliklerinizi ilgili tarım ürünleri önermek için kullan'],
  ['User Email', 'Kullanıcı E-postasi'],
  ['Weekends Only', 'Sadece Hafta Sonu'],
  ['Years of Farming Experience', 'Çiftçilik Deneyimi (Yil)'],
  ['You have unsaved changes. If you continue, unsaved edits will be lost.', 'Kaydedilmemiş değişiklikleriniz var. Devam ederseniz kaydedilmemiş düzenlemeler kaybolur.'],
  ['You will lose access to premium features at the end of your current billing period.', 'Mevcut faturalama dönemi sonunda premium özelliklere erisiminizi kaybedersiniz.'],
  ['Your profile is visible to all marketplace users', 'Profiliniz tüm pazaryeri kullanıcılarina görünür'],
  ['/500 characters', '/500 karakter'],
  ['Category:', 'Kategori:'],
  ['Copy Link', 'Baglantiyi Kopyala'],
  ['Get help and contact support', 'Yardim alin ve destege ulasin'],
  ['Schedule a Tour', 'Tur Planla'],
  ['Schedule your first showing', 'Ilk gösteriminizi planlayin'],
  ['Offer submitted successfully!', 'Teklif başarıyla gönderildi!'],
  ['Payment method removed', 'Ödeme yöntemi kaldırildi'],
  ['Property removed from favorites', 'İlan favorilerden kaldırildi'],
  ['Saved Search Created', 'Kayıtlı Arama Olustürüldu'],
  ['Viewed Property', 'İlan Görüntülendi'],
  ['Message Sent', 'Mesaj Gönderildi'],
  ['Property Search', 'İlan Aramasi'],
  ['Added to Favorites', 'Favorilere Eklendi'],
  ['results found', 'sonuç bulundu'],
  ['active listings', 'aktif ilan'],
  ['saved properties', 'kayıtlı ilan'],
  ['properties selected', 'ilan secildi'],
  ['Added:', 'Eklendi:'],
  ['Blocked on', 'Engellenme Tarihi'],

  // Third-pass coverage (headings + section labels)
  ['Account Settings', 'Hesap Ayarları'],
  ['Profile', 'Profil'],
  ['Privacy', 'Gizlilik'],
  ['Password', 'Şifre'],
  ['Photos', 'Fotoğraflar'],
  ['Select Service Areas', 'Hizmet Bölgelerini Seçin'],
  ['Amount', 'Tutar'],
  ['Date', 'Tarih'],
  ['History', 'Geçmiş'],
  ['Download', 'Indir'],
  ['Expires', 'Son Gecerlilik'],
  ['Month', 'Ay'],
  ['Year', 'Yil'],
  ['City', 'Şehir'],
  ['State', 'Il'],
  ['Public', 'Herkese Acik'],
  ['Private', 'Özel'],
  ['About', 'Hakkinda'],
  ['Anytime', 'Herhangi Bir Zaman'],
  ['Performance', 'Performans'],
  ['Contacted', 'İletişim Kuruldu'],
  ['Showing Scheduled', 'Gösterim Planlandi'],
  ['Offer Pending', 'Teklif Beklemede'],
  ['Book property viewing appointments', 'İlan gösterim randevulari planlayin'],
  ['Create a new property listing', 'Yeni bir ilan oluşturun'],
  ['Create performance analytics', 'Performans analizi oluşturun'],
  ['Cancel subscription?', 'Abonelik iptal edilsin mi?'],
  ['Remove payment method?', 'Ödeme yöntemi kaldırilsin mi?'],
  ['Remove favorite?', 'Favori kaldırilsin mi?'],
  ['Remove selected favorites?', 'Seçili favoriler kaldırilsin mi?'],
  ['Please confirm', 'Lutfen onaylayin'],
  ['TR', 'TR'],
  ['EN', 'EN'],
  ['Facebook', 'Facebook'],
  ['Twitter', 'Twitter'],
  ['LinkedIn', 'LinkedIn'],
  ['Email', 'E-posta'],
  ['Premium Agent Plan - Monthly', 'Premium Danışman Plani - Aylik'],
  ['Seasonal', 'Sezonluk'],
  ['Mixed Crops', 'Karisik Ürünler'],
  ['Livestock', 'Hayvancilik'],
  ['Modern Downtown Loft', 'Modern Şehir Merkezi Loft'],
  ['Suburban Family Home', 'Banliyo Aile Evi'],
  ['Luxury Waterfront Condo', 'Luks Deniz Kenari Daire'],
  ['Cozy Townhouse', 'Sıcak Şehir Evi'],
  ['Historic Brownstone', 'Tarihi Brownstone'],
  ['Modern Studio Apartment', 'Modern Studyo Daire'],
  ['Premium Organic Roma Tomatoes', 'Premium Organik Roma Domatesi'],
  ['Fresh Organic Bell Peppers', 'Taze Organik Dolmalik Biber'],
  ['Premium Sweet Corn', 'Premium Tatlı Mısır'],
  ['Organic Leafy Greens Mix', 'Organik Yaprakli Yesillik Karisimi'],
  ['Senior Real Estate Agent', 'Kıdemli Gayrimenkul Danışmani'],
  ['Real Estate Specialist', 'Gayrimenkul Uzmani'],
  ['Luxury Property Consultant', 'Luks İlan Danışmani'],
  ['Residential Sales Expert', 'Konut Satış Uzmani'],
  ['Modern Downtown Condo', 'Modern Şehir Merkezi Daire'],
  ['Charming Suburban Home', 'Cekici Banliyo Evi'],
  ['Luxury Waterfront Villa', 'Luks Deniz Kenari Villa'],
  ['Viewed Property', 'İlan Görüntülendi'],
  ['Property Search', 'İlan Aramasi'],
  ['Added to Favorites', 'Favorilere Eklendi'],
  ['Message Sent', 'Mesaj Gönderildi'],
  ['Saved Search Created', 'Kayıtlı Arama Olustürüldu'],
  ['Charming Suburban Home - 456 Oak Avenue', 'Cekici Banliyo Evi - 456 Oak Avenue'],
  ['Luxury Waterfront Villa - 789 Lakeside Drive', 'Luks Deniz Kenari Villa - 789 Lakeside Drive'],
  ['Modern Downtown Condo - 123 Main Street', 'Modern Şehir Merkezi Daire - 123 Main Street'],
  ['Downtown Condos - $300K-$500K range', 'Şehir Merkezi Daireler - $300K-$500K aralığı'],
  ['Searched for "3 bedroom houses under $500K"', '"$500K altinda 3 odali evler" arandi'],
  ['Inquired about property tour availability', 'İlan türü uygunlugu soruldu'],
  ['Closing completed: 789 Maple Drive', 'Kapanış tamamlandı: 789 Maple Drive'],
  ['Listing updated: 456 Pine Avenue', 'İlan güncellendi: 456 Pine Avenue'],
  ['Lead converted to client: Sarah Johnson', 'Lead musteriye donustu: Sarah Johnson'],
  ['New lead inquiry for 123 Oak Street', '123 Oak Street için yeni lead talebi'],
  ['Showing scheduled for tomorrow at 2:00 PM', 'Yarın 14:00 için gösterim planlandi'],
  ['Signed in from Chrome on MacOS', 'MacOS uzerinde Chrome ile giriş yapildi'],
  ['Applied organic fertilizer to promote healthy growth and fruit development.', 'Sağlıklı büyüme ve ürün gelişimi için organik gübre uygulandı.'],
  ['Applied organic pest control measures using beneficial insects and neem oil.', 'Faydali bocekler ve neem yagi ile organik zararli kontrolu uygulandı.'],
  ['Planted organic Roma tomato seedlings in prepared beds with proper spacing.', 'Hazirlanan yataklara uygun aralikla organik Roma domates fideleri dikildi.'],
  ['Maintained drip irrigation system and checked soil moisture levels.', 'Damla sulama sistemi bakimi yapildi ve toprak nem seviyeleri kontrol edildi.'],
  ['Harvested ripe Roma tomatoes at peak quality. Sorted and packaged for freshness.', 'En iyi kalitede olgun Roma domatesleri hasat edildi. Tazelik için ayrıldı ve paketlendi.'],
  ['Tilled and prepared soil beds for planting. Applied organic compost and balanced soil pH.', 'Dikim için toprak yatakları sürüldü ve hazırlandı. Organik kompost uygulandı ve toprak pH degeri dengelendi.'],
  ['Seller Dashboard', 'Satıcı Paneli'],
  ['Manage your products, stock visibility, and performance', 'Ürünlerinizi, stok görünürlüğünü ve performansını yönetin'],
  ['Create New Product', 'Yeni Ürün Oluştur'],
  ['Add Product', 'Ürün Ekle'],
  ['Create a new product listing', 'Yeni bir ürün ilanı oluşturun'],
  ['My Products', 'Ürünlerim'],
  ['Manage the products you created in the marketplace flow.', 'Pazaryeri akışında oluşturduğun ürünleri buradan yönetebilirsin.'],
  ['Products could not be loaded', 'Ürünler yüklenemedi'],
  ['Loading marketplace products...', 'Ürünler yükleniyor...'],
  ['Try Again', 'Tekrar Dene'],
  ['No products yet', 'Henüz ürün yok'],
  ['Use "Create New Product" to add your first listing.', 'İlk ürünü eklemek için "Yeni Ürün Oluştur" butonunu kullan.'],
  ['pageSize must not be greater than 100', 'Sayfa boyutu 100 değerinden büyük olamaz.'],
  ['Product Stock Selection (Optional)', 'Stoktan Seçim (Opsiyonel)'],
  ['Available Stock Products', 'Mevcut Stok Ürünleri'],
  ['Product Group', 'Ürün Grubu'],
  ['Product Name', 'Ürün Adı'],
  ['Product Type', 'Ürün Türü'],
  ['Product Group *', 'Ürün Grubu *'],
  ['Product Name *', 'Ürün Adı *'],
  ['Product Type *', 'Ürün Türü *'],
  ['Basic Informatıon', 'Temel Bilgiler'],
  ['Quantity & Priçing', 'Miktar ve Fiyatlama'],
  ['Unit', 'Birim'],
  ['Price per Unit *', 'Birim Fiyat *'],
  ['Available Date *', 'Uygunluk Tarihi *'],
  ['Country *', 'Ülke *'],
  ['Sale Location (City & Country)', 'Satış Konumu (Şehir ve Ülke)'],
  ['Farm Location (Reference)', 'Tarla Konumu (Referans)'],
  ['Additional Details (Optional)', 'Ek Detaylar (Opsiyonel)'],
  ['Product Description', 'Ürün Açıklaması'],
  ['Describe your product...', 'Ürününüzü açıklayın...'],
  ['Activities & Processes', 'Faaliyetler ve Süreçler'],
  ['Test Results', 'Test Sonuçları'],
  ['Field Name', 'Tarla Adı'],
  ['Field Location', 'Tarla Lokasyonu'],
  ['Fertilization Details', 'Gübreleme Detayları'],
  ['Consultant Notes', 'Danışman Notları'],
  ['Expert Notes', 'Uzman Notları'],
  ['Create Product', 'Ürün Oluştur'],
  ['Product group is required', 'Ürün grubu zorunludur'],
  ['Product name is required', 'Ürün adı zorunludur'],
  ['Product type is required', 'Ürün türü zorunludur'],
  ['Quantity must be greater than 0', 'Miktar 0\'dan buyuk olmalidir'],
  ['Price must be greater than 0', 'Fiyat 0\'dan buyuk olmalidir'],
  ['Available date is required', 'Uygunluk tarihi zorunludur'],
  ['Country is required', 'Ülke zorunludur'],
  ['Error submitting product listing:', 'Ürün ilani gönderilirken hata:'],
];
